//mypreset.ts
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const MyPrimeTheme = definePreset(Aura, {
  //Your customizations, see the following sections for examples
  semantic: {
    primary: {
      50: '#fff8ed', // Lightest - very light orange
      100: '#fff0d4', // Light - light orange
      200: '#ffdda8', // Your provided color - light orange/cream
      300: '#ffc470', // Medium light orange
      400: '#ff9f37', // Medium orange
      500: '#ff8413', // Your provided color - main orange
      600: '#f06606', // Your provided color - slightly different orange
      700: '#c74c07', // Darker orange
      800: '#9e3c0e', // Even darker orange
      900: '#7f340f', // Your provided color - burgundy/red
      950: '#451705', // Darkest - deep burgundy
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          inverseColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
      },
      dark: {
        primary: {
          color: '{primary.500}',
          inverseColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
      },
    },
    toast: {
      // :host {
      //   --p-toast-error-background: color-mix(in srgb, black, transparent 25%);
      //   --p-toast-warn-background: color-mix(in srgb, black, transparent 25%);
      //   --p-toast-success-background: color-mix(in srgb, black, transparent 25%);
      //   --p-toast-info-background: color-mix(in srgb, black, transparent 25%);
      //   --p-toast-error-border-color: var(--p-red-600);
      // }
      error: {
        background: 'color-mix(in srgb, black, transparent 25%)',
        borderColor: 'var(--p-red-600)',
      },
    },
  },
  extend: {
    colors: {
      'tan-hide': {
        '50': '#fff6ed',
        '100': '#ffead4',
        '200': '#ffd1a8',
        '300': '#ffb071',
        '400': '#ff914d',
        '500': '#fe6211',
        '600': '#ef4707',
        '700': '#c63208',
        '800': '#9d290f',
        '900': '#7e2410',
        '950': '#440f06',
      },
    },
  },
  components: {
    togglebutton: {
      colorScheme: {
        light: {
          root: {
            background: '{surface.100}',
            borderColor: '{surface.100}',
            checkedBackground: '{surface.100}',
            checkedBorderColor: '{surface.100}',
            hoverBackground: '{surface.200}',
          },
        },
        dark: {
          root: {
            background: '{surface.900}',
            borderColor: '{surface.900}',
            checkedBackground: '{surface.900}',
            checkedBorderColor: '{surface.900}',
            hoverBackground: '{surface.800}',
          },
        },
      },
    },
    toast: {
      // :host {
      //   --p-toast-error-background: color-mix(in srgb, black, transparent 25%);
      //   --p-toast-warn-background: color-mix(in srgb, black, transparent 25%);
      //   --p-toast-success-background: color-mix(in srgb, black, transparent 25%);
      //   --p-toast-info-background: color-mix(in srgb, black, transparent 25%);
      //   --p-toast-error-border-color: var(--p-red-600);
      // }
      error: {
        background: 'color-mix(in srgb, black, transparent 25%)',
        borderColor: 'var(--p-red-600)',
      },
    },
    inputtext: {},
  },
});

export default MyPrimeTheme;
